<template>
  <div class="cotton-inspection-record">
    <MCard :title="$t('巡检记录')" title-align="center">
      <Search v-bind="formConfig" @search="search" :loading="loading" />
      <MTable
        i18n-path="query"
        height="calc(100% - 60px)"
        style="height: calc(100% - 60px)"
        :loading="loading"
        :tableData="tableData"
        :tableColumn="tableColumn"
        :pagiOption="pagiOption"
        :oprateMenu="operation"
        v-on:search="search"
      >
        <template #gps="{ value }">
          <div v-if="isEmpty(value[0]) && isEmpty(value[1])"></div>
          <div
            class="gps"
            v-else
            @click="openMap(value)"
            :title="'地图查看位置' | translateTo('query')"
          >
            <span class="iconfont icon-nav"></span>
            <span class="gps-text">
              {{ `经度: ${value[0]} \n 纬度: ${value[1]}` | translateTo('device') }}
            </span>
          </div>
        </template>
        <template #result="{ value }">
          <span>{{ resultDict[value] | translateTo('query') }}</span>
        </template>
      </MTable>
    </MCard>

    <MultiAlarm ref="multiAlarm" />
  </div>
</template>

<script>
import Search from './components/search';
import MTable from '@/components/mTable/m-table';
import MCard from '@/components/mCard/index.vue';

import { openDevicePointMap } from '@/components/bmapGL/dialog/index';
import { formatTime } from '@/utils/date';
import { arrify, awaitTo, dayTime, formatTimestamp } from '@/utils/utils';
import { isEmpty } from '@/utils/is';
import { getPatrolDetectHisAlarm, updatePatrolDetectDispositionInfo } from '@/api/cotton';
import MultiAlarm from '@/components/dispositionAlarm/multi.vue';

export default {
  name: 'cottonSmolderingDetection',
  props: {
    sn: String
  },
  components: { Search, MTable, MultiAlarm, MCard },
  inject: ['currentOfficeInfo'],
  data() {
    return {
      tableData: [],
      loading: true,
      // 用于清除页面状态 调用 $destroy
      formConfig: {
        model: {
          sns: arrify(this.sn),
          testResult: '',
          stripeCode: '',
          officeIds: [this.currentOfficeInfo.officeId],
          dateRange: [dayTime().begin.getTime(), dayTime().end.getTime()]
        }
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      resultDict: {
        0: '正常',
        1: '异味',
        2: '阴燃'
      },
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '棉包条纹码', prop: 'barCode' },
        {
          label: '定位信息',
          prop: 'gps',
          width: '200px',
          slot: 'gps'
        },
        {
          label: '报警时间',
          prop: 'beginTime'
        }
      ],
      operation: {
        label: '操作',
        width: '250px',
        list: [
          {
            text: '报警处置',
            access: () => true,
            event: (_index, data) => {
              this.alarmDataHandler(data);
            }
          }
        ]
      }
    };
  },
  methods: {
    isEmpty,
    async alarmDataHandler(data) {
      if (isEmpty(data)) {
        return;
      }

      const multiAlarm = this.$refs.multiAlarm;

      multiAlarm.api = obj => {
        return updatePatrolDetectDispositionInfo(obj);
      };

      multiAlarm.show();

      multiAlarm.setFormData(data);

      multiAlarm.setTableData(arrify(data));
    },
    langChangeHandler() {
      this.search();
    },
    formatTimestamp,
    async search() {
      this.loading = true;

      const { model } = this.formConfig;

      const [err, res] = await awaitTo(
        getPatrolDetectHisAlarm({
          sn: model.sns,
          beginTime: model.dateRange?.[0],
          endTime: model.dateRange?.[1],
          offset: this.pagiOption.offset,
          limit: this.pagiOption.limit
        })
      );

      if (err) {
        this.loading = false;
        return;
      }

      const newData = res.data.list.map(data => ({
        ...data,
        gps: [data.longitude, data.latitude],
        beginTime: formatTime(data.beginTime)
      }));

      this.tableData.splice(0, Infinity, ...newData);

      this.pagiOption.total = res.data.total;

      this.loading = false;
    },
    resetSearch() {
      const newData = this.$options.data.call(this);
      this.tableData.splice(0);
      Object.assign(this.formModel, newData.formModel);
      Object.assign(this.pagiOption, newData.pagiOption);
    },
    openMap(coords) {
      openDevicePointMap({ coords: { longitude: coords[0], latitude: coords[1] } });
    }
  },
  watch: {
    sn: {
      handler(n, o) {
        if (n !== o) this.resetSearch();
        this.search();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.cotton-inspection-record {
  height: 100%;
  box-sizing: border-box;

  .m-card_content {
    padding: 20px;
    box-sizing: border-box;

    overflow: auto;

    @include scrollar-style-thin;
  }

  .gps {
    white-space: pre-line;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    cursor: pointer;

    transition: color 0.7s;

    &:hover {
      color: var(--cotton-monitor-gps-hover-color);
      filter: brightness(1.5);
    }

    .iconfont {
      font-size: 28px;
    }

    &-text {
      text-align: left;
    }
  }
}
</style>
